import formatLanguage from '../../../utils/formatLanguage';
import apiClient from '../../apiClient';

export const fetchSectionCardsWithLanguage = async (language) => {
  try {
    const response = await apiClient.post('/home/section_cards/', { 
      language: formatLanguage(language),
     });
    return response.data.section_cards;
  } catch (error) {
    console.error('Error fetching section cards with language:', error);
    throw error;
  }
};

export default {
  fetchSectionCardsWithLanguage,
};
